export const PREFIX = "@admin/";

export const SET_ADMIN_VIEW = `${PREFIX}SET_ADMIN_VIEW`;

